
import {Outlet} from 'react-router-dom';
import { useEffect } from 'react';
import PhosphorIconInit from "../resources/helper/PhosphorIconInit";
import RouteScrollToTop from "../resources/helper/RouteScrollToTop";
import Preloader from '../resources/helper/Preloader';
import ScrollToTop from "react-scroll-to-top";
import ColorInit from '../resources/helper/ColorInit';
import HeaderOne from '../resources/components/HeaderOne';
import FooterOne from '../resources/components/FooterOne';
import BottomFooter from '../resources/components/BottomFooter';



const App = () => {

  useEffect(() => {
    document.title = "VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness"; // Set tab name

    // Set favicon
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = "https://villagezone.shop/images/basics/villagezone.webp"; // Update favicon dynamically
    }
  }, []);


  return (
    <>
      <RouteScrollToTop />
      <PhosphorIconInit />

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* HeaderOne */}
      <HeaderOne />

          <Outlet/>
      
      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default App